import { Box, Flex, Text } from "@chakra-ui/react";
import { Col, Row } from "components/elements";
import { AppTitle } from "components/elements/AppTitle";
import TextStroke from "components/elements/TextStroke";
import { TextEnteringEffect } from "components/shared/TextEnteringEffect";
import { HISTORY_TERMS } from "constants/history";
import React from "react";
import useMetaTags from "react-metatags-hook";
import { useHistory } from "react-router-dom";
import { TermCard } from "./components/TermCard";

const HistoryPage: React.FC = () => {
  const history = useHistory();

  const handleSelectTerm = (termId: string) => {
    history.push(`/history/${termId}`);
  };

  useMetaTags({
    title: "GDGoC-DUT | Lịch sử các nhiệm kì",
    description:
      "Hành trình phát triển và kết nối đam mê công nghệ của GDGoC - DUT qua các thế hệ. Mỗi nhiệm kì là một chặng đường cống hiến, kiến tạo giá trị và đào tạo nên những thế hệ kỹ sư tài năng.",
    charset: "utf8",
    lang: "vi",
    links: [{ rel: "canonical", href: window.location.href }],
  });

  return (
    <Col>
      <Box w="full" pb={{ base: 12, md: 16 }}>
        {/* Header Section */}
        <Flex justifyContent="space-between" alignItems="center">
          <Row
            width={{ base: "full", xl: "60%" }}
            mt={{ base: "6rem", md: "10rem" }}
            mb={{ base: "4rem", lg: "6rem" }}
            paddingLeft={{
              base: "2rem",
              sm: "4rem",
              md: "6rem",
              lg: "0",
              xl: "5rem",
            }}
            pr={{ base: "2rem", sm: "4rem", md: "6rem", lg: "0" }}
            flexDirection={{ base: "column", md: "row" }}
            gap="3rem"
          >
            <TextEnteringEffect durationValue={0.6} delayValue={0.6}>
              <AppTitle>HISTORY</AppTitle>
            </TextEnteringEffect>

            <Box>
              <TextEnteringEffect
                durationValue={0.6}
                easeValue={[0.7, 0.3, 0.3, 0.7]}
                delayValue={0.6}
              >
                <Text fontSize="md" maxWidth="420px" textAlign="justify">
                  Hành trình phát triển và kết nối đam mê công nghệ của GDGoC -
                  DUT qua các thế hệ. Mỗi nhiệm kì là một chặng đường cống hiến,
                  kiến tạo giá trị và đào tạo nên những thế hệ kỹ sư công nghệ
                  tài năng cho cộng đồng.
                </Text>
              </TextEnteringEffect>
            </Box>
          </Row>

          <TextEnteringEffect
            durationValue={0.6}
            delayValue={0.4}
            easeValue={[0.7, 0.3, 0.3, 0.7]}
            direction="horizontal"
            containerProps={{ display: { base: "none", xl: "block" } }}
          >
            <TextStroke title="History" />
          </TextEnteringEffect>
        </Flex>

        {/* Section title & guide */}
        <Box
          mb={8}
          px={{ base: 4, sm: 8, xl: 12 }}
          pt={4}
          borderTop="1px solid"
          borderColor="blackAlpha.200"
        >
          <Flex
            justify="space-between"
            align={{ base: "flex-start", sm: "flex-end" }}
            direction={{ base: "column", sm: "row" }}
            gap={2}
          >
            <Box>
              <Text
                fontSize={{ base: "lg", md: "xl" }}
                fontWeight="800"
                letterSpacing="1px"
                textTransform="uppercase"
                color="gray.900"
              >
                LỊCH SỬ CÁC NHIỆM KÌ
              </Text>
            </Box>
            <Text
              fontSize="2xs"
              fontWeight="700"
              color="gray.400"
              letterSpacing="1.5px"
              textTransform="uppercase"
            >
              ARCHIVE • {HISTORY_TERMS.length} GENERATIONS
            </Text>
          </Flex>
        </Box>

        {/* Terms Wide Ribbon List */}
        <Flex
          direction="column"
          gap={{ base: 6, md: 8 }}
          px={{ base: 4, sm: 8, xl: 12 }}
        >
          {HISTORY_TERMS.map((term) => (
            <TermCard key={term.id} term={term} onSelect={handleSelectTerm} />
          ))}
        </Flex>
      </Box>
    </Col>
  );
};

export default HistoryPage;
